import React from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { StatusBadge } from "../../../../shares/dashboard/DashboardWidgets";


function Tally({ label, value, tone }) {
    return (
        <div className="flex-1 rounded-card bg-surface-sunken px-md py-sm text-center">
            <p className={`text-lg font-semibold tabular-nums ${tone}`}>
                {value == null ? "—" : Number(value).toLocaleString("fa-IR")}
            </p>
            <p className="mt-2xs text-xs text-ink-subtle">{label}</p>
        </div>
    );
}

/**
 * A finished exam: the result, then the breakdown.
 *
 * The old card was a 10x3 grid that showed the score twice (once for large
 * screens, once for small) and read `score.score` in one branch and
 * `user_score` in the other, so the two could disagree. It now reads
 * `user_score` once, and absence is stated rather than implied by a blank.
 *
 * Removed with this rewrite: 72 lines of unused mock exam data that sat below
 * the component.
 */
const PreviousExam = ({ exam, index }) => {
    if (!exam) return null;

    const attended = Boolean(exam.score?.exam_peresence);
    const wrong = exam.score?.wrong_counts ?? 0;
    const blank = exam.score?.none_counts ?? 0;
    const correct = exam.score?.correct_counts ?? (Array.isArray(exam.u_q_list) ? exam.u_q_list.length - Number(wrong) - Number(blank) : null);

    return (
        <article
            className="dash-rise flex flex-col gap-lg rounded-panel border border-rule-subtle bg-surface p-xl shadow-card"
            style={{ "--i": index }}
        >
            <div className="flex flex-wrap items-start justify-between gap-md">
                <div className="min-w-0">
                    <h3 className="text-base font-semibold text-ink">
                        {exam?.name || exam?.exam_name}
                    </h3>
                    {exam?.name && exam?.exam_name && (
                        <p className="mt-2xs text-sm text-ink-subtle">
                            {exam.exam_name}
                        </p>
                    )}
                </div>

                {attended ? (
                    <div className="flex items-baseline gap-2xs">
                        <span className="text-sm text-ink-subtle">نمره</span>
                        <span className="text-2xl font-semibold tabular-nums text-primary">
                            {Number(exam?.user_score ?? 0).toLocaleString("fa-IR")}
                        </span>
                    </div>
                ) : (
                    <StatusBadge label="غایب" tone="danger" />
                )}
            </div>

            {attended && (
                <div className="flex gap-sm">
                    <Tally label="درست" value={correct} tone="text-success" />
                    <Tally label="غلط" value={wrong} tone="text-danger" />
                    <Tally label="بی‌پاسخ" value={blank} tone="text-ink-muted" />
                </div>
            )}

            {exam?.exam_answer_file && (
                <a
                    href={new URL(exam.exam_answer_file, process.env.REACT_APP_API_URL + "/").href}
                    download
                    className="inline-flex w-fit items-center gap-xs rounded-soft border border-rule px-lg py-xs text-sm text-ink-muted transition-colors duration-150 hover:bg-surface-sunken hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none"
                >
                    <DownloadIcon sx={{ fontSize: "1.8rem" }} />
                    برگه تصحیح‌شده
                </a>
            )}
        </article>
    );
};

export default PreviousExam;
